angular.module('picmonicng').controller('RedeemController', [
  '$scope',
  '$controller',
  '$stateParams',
  '$filter',
  '$timeout',
  '$q',
  '$location',
  'ngBowser',
  'UserService',
  'PromoCodesResource',
  'AccessCodesResource',
  'Schools',
  'MarketOptionsConfig',
  'toaster',
  '$cookies',
  function (
    $scope,
    $controller,
    $stateParams,
    $filter,
    $timeout,
    $q,
    $location,
    ngBowser,
    UserService,
    PromoCodesResource,
    AccessCodesResource,
    Schools,
    MarketOptionsConfig,
    toaster,
    $cookies
  ) {
    $controller('LoginController', { $scope: $scope });
    $controller('RegisterStep1Controller', { $scope: $scope });

    // Form Model Objects
    $scope.MarketOptionsConfig = MarketOptionsConfig;
    $scope.schools = [];
    $scope.selectedSchool = null;
    $scope.schoolSelectorVisible = false;
    $scope.access_code = '';
    $scope.validatedAccessCode = {};
    $scope.selectedTab = 'login';
    $scope.activeStep = 1;
    $scope.$emit('endInteraction');
    $scope.UserService = UserService;
    $scope.user_count = window.pls_config.user_count;
    $scope.$stateParams = $stateParams;

    if ($cookies.get('pls_user_email')) {
      $scope.user.email = $cookies.get('pls_user_email');
    }

    var years = [];
    var currentYear = new Date().getFullYear();
    for (var i = 0; i < 12; i++) {
      years.push(currentYear + i);
    }
    $scope.years = years;

    if ($stateParams.access_code) {
      $scope.accessCode = AccessCodesResource.get({
        code: $stateParams.access_code,
      });
    };

    $scope.setStep = function (step) {
      $scope.activeStep = step;
    };

    $scope.selectTab = function (tab) {
      $scope.selectedTab = tab;
    };

    $scope.copyReferralURL = function () {
      toaster.success('Copied', 'URL has been copied to the clipboard.');
    };

    $scope.setSchool = function (item) {
      $scope.selectedSchool = item;
    };

    $scope.submitAccessCode = function () {
      var schoolId;

      if (UserService.user.school && UserService.user.school.id) {
        schoolId = UserService.user.school.id;
      } else if ($scope.selectedSchool && $scope.selectedSchool.id) {
        schoolId = $scope.selectedSchool.id;
      }

      if ($scope.access_code && !schoolId) {
        $scope.error = 'You must select a school.';
        $scope.loadingMode = 'accesscode';
        $scope.loading = false;
        return;
      }

      if ($scope.access_code && schoolId) {
        $scope.loading = true;
        $scope.error = '';
        $scope.loadingMode = 'accesscode';

        // Save school id first, if not set
        var user = {};
        if (
          (!UserService.user.school.id && $scope.selectedSchool.id) ||
          ($scope.schoolSelectorVisible &&
            $scope.selectedSchool.id &&
            UserService.user.school &&
            $scope.selectedSchool.id !== UserService.user.school.id)
        ) {
          UserService.user.school = { id: $scope.selectedSchool.id };
          user = UserService.user.$update();
        } else {
          var promise = $q.defer();
          user = promise.promise;
          promise.resolve();
        }

        user.then(
          function () {
            var result = PromoCodesResource.validate({
              access_code: $scope.access_code,
            });

            result.$promise.then(
              function (data) {
                $scope.validatedAccessCode = data;

                // Start processing access code order
                var result = AccessCodesResource.redeem({
                  access_code: $scope.validatedAccessCode.code,
                  source_device: ngBowser.getPlatformType(),
                  source_browser: ngBowser.browser.name,
                });

                result.$promise.then(
                  function () {
                    $scope.setStep(3);
                  },
                  function (result) {
                    $scope.error = result.data.message;
                    $scope.loading = false;
                  }
                );
              },
              function (result) {
                $scope.error = result.data.message;
                $scope.loading = false;
              }
            );
          },
          function (result) {
            $scope.error = result.data.message;
            $scope.loading = false;
          }
        );
      }
    };

    $scope.submitRedeemLogin = function ($event, redirect) {
      $scope.submitLogin($event, redirect, null, function () {
        if (!UserService.user.lead) {
          var params = $.param($location.search());
          window.location = '/register/step2?redirect=%2Fredeem' + (params ? encodeURIComponent('?' + params) : '');
        }
      });
    };

    $scope.checkUsersSchool = function () {
      if (!UserService.user.school.id) {
        $scope.schoolSelectorVisible = true;

        Schools.search({ market_id: UserService.user.lead }, function (data) {
          $scope.schools = data;
        });
      }
    };

    // When the user logs in reselect the option
    $scope.$watch(
      function () {
        return UserService.user.user_id;
      },
      function (newValue, oldValue) {
        if (UserService.user.user_id && newValue !== oldValue) {
          if ($stateParams.school_id && !UserService.user.school.id) {
            UserService.user.school = { id: $stateParams.school_id };
            UserService.user.$update();
          }
          $scope.checkUsersSchool();
          $scope.setStep(2);
          $scope.referral_url = UserService.getFullReferralUrl();
        }
      }
    );

    if (UserService.user.user_id) {
      if ($stateParams.school_id && !UserService.user.school.id) {
        UserService.user.school = { id: $stateParams.school_id };
        UserService.user.$update();
      }
      $scope.checkUsersSchool();
      $scope.setStep(2);
      $scope.referral_url = UserService.getFullReferralUrl();
    }

    // Auto fill access code
    if ($stateParams.access_code) {
      $scope.access_code = $stateParams.access_code;
    }
  },
]);
